import type { StorePrice } from "@medusajs/types"

export type FeaturedProduct = {
  id: string;
  title: string;
  handle: string;
  thumbnail?: string;
};

export type VariantPrice = {
  calculated_price_number: number;
  calculated_price: string;
  original_price_number: number;
  original_price: string;
  currency_code: string;
  price_type: string;
  percentage_diff: string;
};

export type StoreFreeShippingPrice = StorePrice & {
  target_reached: boolean;
  target_remaining: number;
  remaining_percentage: number;
};

export enum CheckoutStepKey {
  ADDRESSES = "addresses",
  PICKUP = "pickup",
  PAYMENT = "payment",
  REVIEW = "review",
}

export type CheckoutStep = {
  key: CheckoutStepKey
  title: string
  progressTitle?: string
  description: string
  completed: boolean
}

export type AddressFormData = {
  first_name: string
  last_name: string
  company: string
  address_1: string
  address_2: string
  city: string
  postal_code: string
  province: string
  country_code: string
  phone: string
}
